<template>
  <ReposListAdminTable
    showCreatedAt
    showUpdatedAt
    :repos="repos"
    @delete="deleteRepo"
  ></ReposListAdminTable>
</template>

<script>
import { ReposMixin } from "@/mixins";
import ReposListAdminTable from "@/components/ReposListAdminTable";
export default {
  name: "ReposDraft",
  mixins: [ReposMixin],
  components: {
    ReposListAdminTable
  },
  created() {
    this.listRepos(true);
  }
};
</script>
